export default "__VITE_ASSET__DRs_gXlZ__"